var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-image"},[_c('el-carousel',{attrs:{"height":"600px"}},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.id},[_c('el-image',{staticClass:"image",attrs:{"src":item.webImg,"fit":"cover"}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }